import { CSSProperties, useEffect, useState } from "react";

export default function PhotoLoader(props: {
    src: string;
    width?: number;
    height?: number;
    style?: CSSProperties;
    onClick?: () => void;
}) {
    const [imageLoaded, setImageLoaded] = useState(false);

    useEffect(() => {
        setImageLoaded(false);
    }, [props.src]);

    const handleClick = () => {
        if (props.onClick) {
            props.onClick();
        }
    };

    const handleImageError = (e) => {
        e.target.onerror = null;
    };

    const handleImageLoad = () => {
        setTimeout(() => {
            setImageLoaded(true);
        });
    };

    return (
        <img
            onClick={handleClick}
            alt={"no description"}
            onError={handleImageError}
            onLoad={handleImageLoad}
            className={imageLoaded ? "img-fade-in" : ""}
            style={{ ...props.style, opacity: 0 }}
            width={props.width}
            height={props.height}
            src={props.src}
        />
    );
}
